/* ═══════════════════════════════════════════════════════════════════
   MATRIKAR — Personalization picker — assets/mk-personalization.js
   2026-08-30

   Pilote le sélecteur de finition du tapis conducteur (snippets/mk-personalization.liquid) :
     · état visuel des 4 cartes + libellé du choix courant
     · propriété technique `_mk_perso` tenue à jour dans le formulaire produit
     · lightbox "View larger" (image + légende, et 2e photo « dans l'auto » si la carte en a une)
     · expose window.mkPersoSelection() → { code, label, variantId } que
       cart-unified.js lit pour ajouter la ligne add-on payante après le tapis.

   NE FIXE AUCUN PRIX. L'autorité de prix, ce sont les variantes du produit
   `mat-personalization` (UNLISTED). Ce module ne fait que désigner laquelle ajouter.

   Le popover (i) est déjà géré globalement par mkv5-pdp.js (classes .mkcov-*),
   on ne le redéclare pas ici.
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var ROOT_SEL = '[data-mkperso]';

  function root() { return document.querySelector(ROOT_SEL); }

  /* ---- mémoire du choix, entre deux rendus de la section ----
     2026-09-17 — CORRECTIF. Un swap couleur remplace tout le HTML de la section produit par du HTML
     frais venu du serveur (mkv5-pdp.js : root.innerHTML = fresh.innerHTML). Le bloc revient donc
     comme au premier chargement : radio sur `none`, tiroir refermé, et surtout les deux champs
     cachés de nouveau porteurs de leur `name`. Rien ne relançait syncState() après ce remplacement,
     d'où DEUX dégâts mesurés :
       1. la commande repartait avec une étiquette "Personalization" VIDE (vu sur la #1662 du
          16/09/2026), puisque plus personne ne retirait le `name` des champs ;
       2. un client qui avait choisi une finition PAYANTE avant de changer de couleur la perdait
          sans le voir — la barre repliée réaffiche l'accroche, pas le choix.
     On retient donc le code choisi et on le REPOSE sur le HTML frais. mkv5-pdp.js émet
     'variant:changed' juste après le remplacement : c'est notre point d'accroche. */
  var lastChoice = 'none';

  function rememberChoice() {
    var input = checkedInput();
    lastChoice = (input && input.getAttribute('data-mkperso-code')) || 'none';
  }

  function restoreChoice() {
    var el = root();
    if (!el || lastChoice === 'none') return;
    var input = el.querySelector('input[data-mkperso-code="' + lastChoice + '"]');
    // La finition peut avoir disparu de l'offre entre-temps : on ne force rien si elle n'existe plus.
    if (input && !input.checked) input.checked = true;
  }

  function checkedInput(scope) {
    return (scope || document).querySelector(ROOT_SEL + ' input[type="radio"]:checked');
  }

  /* ---- lecture publique : consommée par cart-unified.js au moment de l'ajout ---- */
  window.mkPersoSelection = function () {
    var input = checkedInput();
    if (!input) return { code: 'none', label: '', variantId: null, image: '' };
    var vid = input.getAttribute('data-variant-id');
    // Vignette de la carte choisie : le panier l'affiche sur sa sous-ligne. On prend la petite
    // (déjà en cache), pas la grande : la ligne de panier ne dépasse pas 44 px.
    var card = input.closest('[data-mkperso-card]');
    var zoom = card && card.querySelector('[data-mkperso-zoom]');
    return {
      code: input.getAttribute('data-mkperso-code') || 'none',
      label: input.getAttribute('data-mkperso-label') || '',
      variantId: vid ? parseInt(vid, 10) : null,
      image: (zoom && zoom.getAttribute('data-image-small')) || ''
    };
  };

  /* ---- état visuel + propriété technique ---- */
  function syncState() {
    var el = root();
    if (!el) return;

    el.querySelectorAll('[data-mkperso-card]').forEach(function (card) {
      var input = card.querySelector('input[type="radio"]');
      card.classList.toggle('mkperso-card--selected', !!(input && input.checked));
    });

    var sel = window.mkPersoSelection();

    // Tant que le client n'a rien choisi de payant, la barre PROPOSE au lieu de constater :
    // "Add your logo or a name" plutôt que "Without Logo or Text", qui ne donnait aucune raison
    // d'ouvrir le tiroir. Dès qu'une finition est prise, elle affiche le choix.
    var label = el.querySelector('[data-mkperso-selected]');
    if (label) {
      var teaser = (window.MK_I18N && window.MK_I18N.perso_teaser) || '';
      label.textContent = (sel.code === 'none' && teaser) ? teaser : sel.label;
      label.classList.toggle('is-teaser', sel.code === 'none' && !!teaser);
    }

    // Finition gratuite = AUCUNE propriété sur la ligne.
    //
    // MESURÉ le 2026-08-30 : contrairement à ce qu'on lit souvent, Shopify n'élague PAS une
    // propriété à valeur vide envoyée par /cart/add.js — la ligne repartait avec un
    // "Personalization": "" qui se serait affiché vide au panier et sur la commande. On retire donc
    // carrément le `name` des champs concernés : un champ sans name n'est pas soumis, et le radio
    // reste cochable normalement.
    var paid = sel.code !== 'none';

    var codeInput = el.querySelector('[data-mkperso-code-input]');
    if (codeInput) {
      codeInput.value = sel.code;
      setSubmittable(codeInput, paid);
    }

    var labelInput = el.querySelector('[data-mkperso-label-input]');
    if (labelInput) {
      labelInput.value = paid ? sel.label : '';
      setSubmittable(labelInput, paid);
    }
  }

  // Bascule la participation d'un champ caché à l'envoi du formulaire (un champ sans `name` n'est
  // pas soumis), en mémorisant son name d'origine pour pouvoir le rétablir. Ne JAMAIS appliquer aux
  // radios : ils forment un groupe exclusif par leur name, en retirer un le sortirait du groupe et
  // deux boutons pourraient rester cochés en même temps.
  function setSubmittable(input, on) {
    if (on) {
      var saved = input.getAttribute('data-mkperso-name');
      if (!input.getAttribute('name') && saved) input.setAttribute('name', saved);
    } else if (input.getAttribute('name')) {
      input.setAttribute('data-mkperso-name', input.getAttribute('name'));
      input.removeAttribute('name');
    }
  }

  /* ---- lightbox ---- */
  var lastFocus = null;

  function lightbox() { return document.querySelector('[data-mkperso-lightbox]'); }

  // La lightbox est rendue DANS la colonne produit, donc à l'intérieur du contexte d'empilement
  // de la section (safe-sticky + galerie en position: sticky). Un z-index, même énorme, n'y sert à
  // rien : il n'est comparé qu'aux frères de ce contexte, pas au header fixe de la page, qui passait
  // donc PAR-DESSUS l'image dès qu'il était visible. On la remonte en enfant direct de <body>, où
  // son z-index compte face au reste de la page. Déplacement fait une seule fois.
  function detachLightbox() {
    var lb = lightbox();
    if (lb && lb.parentNode !== document.body) document.body.appendChild(lb);
  }

  /* 2026-10-05 — Une carte peut porter une 2e photo (le tapis posé dans l'auto). La fenêtre devient
     alors un mini-diaporama de deux vues : gros plan d'abord, photo dans l'auto ensuite, avec flèches,
     points, flèches du clavier et glissement du doigt. Sans 2e photo, rien ne change. */
  var slides = [];
  var slideIndex = 0;

  function showSlide(i) {
    var lb = lightbox();
    if (!lb || !slides.length) return;
    slideIndex = (i + slides.length) % slides.length;
    var s = slides[slideIndex];
    var img = lb.querySelector('[data-mkperso-lightbox-img]');
    if (!img) return;

    img.setAttribute('alt', s.alt);
    // On peint TOUT DE SUITE ce qui est déjà en cache (la vignette du gros plan), puis on substitue
    // la grande une fois décodée. Sans ça la fenêtre restait vide 1 à 2 secondes.
    img.setAttribute('src', s.small || s.big);
    if (s.big && s.big !== s.small) {
      var full = new Image();
      full.onload = function () {
        // Le client a pu changer de vue ou de carte entre-temps : ne remplacer que si c'est toujours celle-ci.
        if (img.getAttribute('data-mk-pending') === s.big) img.setAttribute('src', s.big);
      };
      img.setAttribute('data-mk-pending', s.big);
      full.src = s.big;
    }

    var dots = lb.querySelectorAll('[data-mkperso-lightbox-dots] span');
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === slideIndex); });
  }

  function openLightbox(trigger) {
    var lb = lightbox();
    if (!lb) return;

    var img = lb.querySelector('[data-mkperso-lightbox-img]');
    var cap = lb.querySelector('[data-mkperso-lightbox-caption]');
    var big = trigger.getAttribute('data-image');
    var small = trigger.getAttribute('data-image-small');
    var big2 = trigger.getAttribute('data-image2');
    var label = trigger.getAttribute('data-label') || '';

    slides = [];
    if (big || small) slides.push({ small: small, big: big, alt: label });
    if (slides.length && big2) {
      slides.push({ small: '', big: big2, alt: trigger.getAttribute('data-alt2') || label });
      var pre = new Image(); // la 2e vue s'affiche sans attente quand le client avance
      pre.src = big2;
    }

    var multi = slides.length > 1;
    lb.querySelectorAll('[data-mkperso-lightbox-prev], [data-mkperso-lightbox-next], [data-mkperso-lightbox-dots]')
      .forEach(function (n) { n.hidden = !multi; });

    if (img) {
      if (slides.length) {
        img.parentNode.hidden = false;
        showSlide(0);
      } else {
        // Visuel pas encore branché : on ouvre quand même sur la légende seule
        // plutôt que d'afficher une image cassée.
        img.removeAttribute('src');
        img.parentNode.hidden = true;
      }
    }
    if (cap) cap.textContent = trigger.getAttribute('data-caption') || '';
    var note = lb.querySelector('[data-mkperso-lightbox-set]');
    if (note) note.textContent = trigger.getAttribute('data-price-note') || '';

    lastFocus = document.activeElement;
    lb.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var close = lb.querySelector('.mkperso-lightbox__close');
    if (close) close.focus();
  }

  function closeLightbox() {
    var lb = lightbox();
    if (!lb || lb.hidden) return;
    lb.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  /* ---- tiroir ---- */
  // Même mécanique que les tiroirs Material & Quality (pdp-accordion-content.liquid) : une classe
  // sur le conteneur, la hauteur animée par grid-template-rows. Classes distinctes à dessein : le
  // handler natif bind tous les .accordion-header, et deux bascules par clic ne bougeraient rien.
  function toggleAccordion(head) {
    var acc = head.closest('[data-mkperso-acc]');
    if (!acc) return;
    var open = !acc.classList.contains('is-open');
    acc.classList.toggle('is-open', open);
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* ---- délégation : survit aux re-render AJAX du swap couleur ---- */
  if (!window.__mkperso_bound) {
    window.__mkperso_bound = true;

    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest(ROOT_SEL)) { rememberChoice(); syncState(); }
    });

    // Le swap couleur re-rend la section produit et réinsère une lightbox dans la colonne.
    document.addEventListener('mk:cart:changed', detachLightbox);
    window.addEventListener('pageshow', detachLightbox);

    // Après CHAQUE re-rendu de la section (swap couleur, changement de couverture) : on remonte la
    // lightbox hors du contexte d'empilement, on repose le choix du client sur le HTML frais, PUIS
    // on resynchronise. L'ordre compte : syncState() avant restoreChoice() débrancherait les champs
    // et effacerait le choix qu'on vient de vouloir sauver.
    document.addEventListener('variant:changed', function () {
      detachLightbox();
      restoreChoice();
      syncState();
    });

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;

      if (e.target.closest('[data-mkperso-lightbox-close]')) { closeLightbox(); return; }
      if (e.target.closest('[data-mkperso-lightbox-prev]')) { showSlide(slideIndex - 1); return; }
      if (e.target.closest('[data-mkperso-lightbox-next]')) { showSlide(slideIndex + 1); return; }

      // Tiroir. Le bouton (i) vit dans l'en-tête : son clic ouvre le popover (mkv5-pdp.js) et ne
      // doit PAS basculer le tiroir, d'où la sortie anticipée.
      var head = e.target.closest('[data-mkperso-acc-toggle]');
      if (head && !e.target.closest('[data-mkperso-info]')) { toggleAccordion(head); return; }

      // Le bouton Add SÉLECTIONNE la finition. Comme dans Frequently Purchased Together, la carte
      // elle-même n'est pas cliquable : c'est le bouton, et lui seul, qui agit.
      var add = e.target.closest('[data-mkperso-add]');
      if (add) {
        var card = add.closest('[data-mkperso-card]');
        var radio = card && card.querySelector('input[type="radio"]');
        if (radio && !radio.checked) { radio.checked = true; }
        rememberChoice();
        syncState();
        return;
      }

      var zoom = e.target.closest('[data-mkperso-zoom]');
      if (zoom) { e.preventDefault(); openLightbox(zoom); }
    });

    // Desktop : on précharge la grande version au survol de la vignette, une seule fois par carte.
    document.addEventListener('mouseover', function (e) {
      var zoom = e.target && e.target.closest ? e.target.closest('[data-mkperso-zoom]') : null;
      if (!zoom || zoom.hasAttribute('data-mk-prefetched')) return;
      var big = zoom.getAttribute('data-image');
      if (!big) return;
      zoom.setAttribute('data-mk-prefetched', '1');
      var pre = new Image();
      pre.src = big;
    });

    // Au doigt : glisser horizontalement sur la photo change de vue (seuil 40 px, et seulement si le
    // geste est plus horizontal que vertical, pour ne pas voler un défilement).
    var touchX = null, touchY = null;
    document.addEventListener('touchstart', function (e) {
      if (!e.target.closest || !e.target.closest('.mkperso-lightbox__media') || slides.length < 2) { touchX = null; return; }
      touchX = e.touches[0].clientX; touchY = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX, dy = e.changedTouches[0].clientY - touchY;
      touchX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) showSlide(slideIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeLightbox(); return; }
      var lbOpen = lightbox();
      if (lbOpen && !lbOpen.hidden && slides.length > 1 && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
        e.preventDefault();
        showSlide(slideIndex + (e.key === 'ArrowRight' ? 1 : -1));
        return;
      }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if (!e.target || !e.target.closest) return;

      var zoom = e.target.closest('[data-mkperso-zoom]');
      if (zoom) { e.preventDefault(); openLightbox(zoom); return; }

      // Le bouton Add est un vrai <button> : Entrée / Espace y déclenchent déjà un clic natif,
      // rien à faire ici.

      var head = e.target.closest('[data-mkperso-acc-toggle]');
      if (head && !e.target.closest('[data-mkperso-info]')) { e.preventDefault(); toggleAccordion(head); }
    });
  }

  function boot() { detachLightbox(); syncState(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
